import { useEffect, useMemo } from "react";
import { useGetNotificationsQuery } from "../../../common/api/notification";
import { useEmployeeId } from "../../../common/utils/useEmployeeId";
import notificationImage from "../../../common/images/notification.svg";
import { mapNotificationToItem } from "../../../common/utils/mapNotificationToItem";
import { useAppSelector } from "../../../app/hooks";

type DashboardNotificationsViewData = {
    head: { title: string; iconUrl: string };
    items: ReturnType<typeof mapNotificationToItem>;
};

type UseDashboardEmployeeNotificationsResult = {
    loading: boolean;
    isEmpty: boolean;
    viewData?: DashboardNotificationsViewData;
};

export const useDashboardEmployeeNotifications =
    (): UseDashboardEmployeeNotificationsResult => {
        const employeeId = useEmployeeId();
        const { isPostCreateCertificateSuccess } = useAppSelector(
            (state) => state.createCertificateModal,
        );

        const { data, isLoading, isFetching, refetch } =
            useGetNotificationsQuery({
                filter: { employee_id: employeeId },
            });

        useEffect(() => {
            if (isPostCreateCertificateSuccess) {
                refetch();
            }
        }, [isPostCreateCertificateSuccess, refetch]);

        const loading = isLoading || isFetching;

        const viewData = useMemo(() => {
            if (!data?.data?.length) return undefined;
            return {
                head: {
                    title: "Belangrijke meldingen",
                    iconUrl: notificationImage,
                },
                items: mapNotificationToItem(data.data, 4),
            } as const;
        }, [data]);

        const isEmpty = !loading && !data?.data?.length;

        return { loading, isEmpty, viewData };
    };
